export const GATEWAY_VERIFY_PATH = '/api/v1/gateway/verify';

export type VerificationReason = 'verified' | 'rejected' | 'unavailable' | 'not_configured';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export async function postVerification(
  baseUrl: string,
  token: string,
  timeoutMs: number,
): Promise<VerificationReason> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`${baseUrl}${GATEWAY_VERIFY_PATH}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ token }),
      signal: controller.signal,
    });
    if (!response.ok) {
      return 'unavailable';
    }
    const payload: unknown = await response.json();
    if (isRecord(payload) && payload['verified'] === true) {
      return 'verified';
    }
    const reason = isRecord(payload) ? payload['reason'] : null;
    if (reason === 'not_configured') {
      return 'not_configured';
    }
    if (reason === 'unavailable') {
      return 'unavailable';
    }
    return 'rejected';
  } catch {
    return 'unavailable';
  } finally {
    window.clearTimeout(timer);
  }
}
